<template>
    <div class="assessDetail-page">
        <div class="container">
            <div class="title-wrap">
                <h1>{{mainData.title}}</h1>
                <p class="info">
                    来源 {{mainData.sourceName}}
                    <span v-if="mainData.datetime" class="time">{{mainData.datetime | formatTime2}}</span>
                </p>
            </div>
            <div class="content">
                <div class="video-wrap">
                    <video :src="mainData.link" controls></video>
                    <span v-if="!isPlay" class="poster bg-cover flex-center" :style="{'background-image':'url('+mainData.background+')'}" @click="play">
                        <img src="~@assets/img/play-white.png">
                    </span>
                </div>
                <p>视频简介</p>
                <p class="desc">{{mainData.desc}}</p>
            </div>
            <shareBox :shareData = "shareData"></shareBox>
            <!-- <p class="more-title">更多探物资讯</p>
            <div class="assess-list">
                <newsItem v-for="(item,index) in listData" :key="index" :item = "item" class="item" @click.native="goDetail(item)"></newsItem>
            </div> -->
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import newsItem from '@components/newsItem';
    import shareBox from '@components/shareBox';
    
    export default {
		data() {
			return {
                askData:{},
                mainData:{},
                listData:[],
                shareData:{},
                isPlay:false
			}
        },
        components: {
            newsItem,
            shareBox
		},
        created(){
            this.askData.videoId = this.$route.query.id;
            this.initData();
        },
        methods:{
            initData(){
                network(CONFIG.videoDetail,this.askData).then(res => {
                    let details = res.details;
                    this.mainData = details;
                    for(let i = 0 ; i < 3 ; i++){
                        this.listData.push({
                            id:details.videoId,
                            image:details.background,
                            title:details.title,
                            time:this.formatTime(details.datetime)
                        })
                    }
                    this.shareData = {
                        image:details.background,
                        title:details.title,
                        url:window.location.href,
                    }
                });
            },
            play(){
                document.querySelector('video').play();
                this.isPlay = true;
            }
        }
    }
</script>

<style lang="scss">
    .assessDetail-page{
        .title-wrap{
            color: #333333;
            padding-bottom: 20px;
            padding-top: 50px;
            h1{
                font-size: 36px;
                line-height: 1.3888;
                margin-bottom: 10px;
            }
            .info{
                font-size: 14px;
                line-height: 1.4285;
                .time{
                    padding-left: 25px;
                }
            }
        }
        .content{
            padding-bottom: 30px;
            border-bottom: 1px solid #EEEEEE;
            .video-wrap{
                position: relative;
                margin-bottom: 18px;
                video{
                    display: block;
                    width: 100%;
                }
                .poster{
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    cursor: pointer;
                    img{
                        width: 80px;
                        opacity: 0.8;
                        transition: opacity 0.2s;
                    }
                    &:hover img{
                        opacity: 1;
                    }
                }
            }
            .desc{
                line-height: 2;
                margin-top: 6px;
            }
        }
        .more-title{
            font-size: 26px;
            line-height: 1.423;
            margin-bottom: 24px;
            text-align: center;
            letter-spacing: 1px;
        }
        .assess-list{
            padding-bottom: 100px;
            .item{
                .image{
                    padding-bottom: 56.28%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/assessDetail.vue